import * as actions from './actions';

export const INITIAL_STATE = {
    impactAnalysisId: '',
    initialised: false,
    impactSummaryRows: [],
    tradedPricedToday: {
        trades: [],
        originalTrades: []
    },
    pricingParams: []
};


export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_IMPACT_ID: {
            return {
                ...state,
                impactAnalysisId: action.id
            };
        }
        case actions.SET_INITIALISED: {
            return {
                ...state,
                initialised: true
            };
        }
        case actions.SET_SUMMARY_TRADES: {
            return {
                ...state,
                tradedPricedToday: {
                    trades: action.trades,
                    originalTradesSelection: action.trades
                }
            };
        }
        case actions.SET_SUMMARY_IMPACT_ROWS: {
            return {
                ...state,
                impactSummaryRows: action.data
            };
        }
        case actions.SET_PRICING_PARAMETERS: {
            return {
                ...state,
                pricingParams: action.data
            };
        }
        default:
            return state;
    }
}
